<div
  class="zag-page-layout__container"
  [class.zag-page-layout--padding-sm]="padding() === 'sm'"
  [class.zag-page-layout--padding-md]="padding() === 'md'"
  [class.zag-page-layout--padding-lg]="padding() === 'lg'"
>
  <ng-content></ng-content>
</div>
